import i18nService from "@/core/services/i18n.service.js";

/**
 * Shared helpers usable from any module (Vue components, plain JS, stores).
 * Prefer adding small, stateless functions here instead of many single-purpose files.
 */

/**
 * @param {string} [lang]
 * @returns {boolean}
 */
export function isRTLScreen(lang) {
  return i18nService.isRTL(lang);
}
